module.exports = __webpack_public_path__ + "media/img/clients/client8-53b717402e9307018a826921c2ac1af5.svg";